<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row class="bg-kiri" no-gutters>
          <v-col cols="2"></v-col>
          <v-col cols="10" class="pa-5" style="background-color: white">
            <v-list-item class="px-0">
              <v-list-item-avatar color="blue">
                <v-icon dark>mdi-office-building-outline</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col cols="12" md="4">
                    <div class="body-1 mb-0">
                      <strong class="blue--text">
                        {{ $getDeepObj(ajuan, 'sekolah.nama') || '-' }}
                      </strong>
                    </div>
                    <div class="body-2">
                      <strong>NPSN:</strong>
                      {{ $getDeepObj(ajuan, 'sekolah.npsn') || '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="caption grey--text text-lighten-1">
                      Alamat Sekolah
                    </div>
                    <div class="body-2 mb-0">
                      {{ $getDeepObj(ajuan, 'sekolah.alamat') }}<br />
                      {{
                        [
                          $getDeepObj(ajuan, 'sekolah.m_kota.keterangan'),
                          $getDeepObj(ajuan, 'sekolah.m_propinsi.keterangan'),
                        ].join(' - ')
                      }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="caption grey--text text-lighten-1">
                      Status Sekolah
                    </div>
                    <div class="body-2 mb-0">
                      {{ +$getDeepObj(ajuan, 'sekolah.is_negeri') === 1 ? 'Negeri' : 'Swasta' }}
                    </div>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card tile flat class="my-5">
      <v-card-text v-if="isPreview">
        <v-list>
          <div v-for="(peserta, id) in pesertas" :key="id">
            <v-divider v-if="id > 0" />
            <v-list-item>
              <v-list-item-avatar>
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" md="4">
                    <div class="black--text subtitle-2">
                      {{ $getDeepObj(peserta, 'ptk.nama') || '-' }}
                    </div>
                    <div class="caption">
                      SIMPKB ID:
                      <strong> {{ $getDeepObj(peserta, 'ptk.ptk_id') }} </strong>
                      <br />
                      NIP:
                      <strong>
                        {{ $getDeepObj(peserta, 'ptk.nip') || $getDeepObj(peserta, 'ptk.ptk_info_dapodik.nip') || '-' }}
                      </strong>
                      <br />
                      NIK:
                      <strong>
                        {{ $getDeepObj(peserta, 'ptk.nik') || $getDeepObj(peserta, 'ptk.ptk_info_dapodik.nik') || '-' }}
                      </strong>
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div class="caption grey--text text-lighten-1">
                      Tempat Lahir
                    </div>
                    <div class="body-2 mb-0">
                      {{ $getDeepObj(peserta, 'ptk.tmp_lahir') }}
                    </div>
                    <div class="caption grey--text text-lighten-1">
                      Tanggal Lahir
                    </div>
                    <div class="body-2 mb-0">
                      {{ $localDate($getDeepObj(peserta, 'ptk.tgl_lahir')) }}
                    </div>
                    <div class="caption grey--text text-lighten-1">
                      Usia
                    </div>
                    <div class="body-2 mb-0">
                      {{ $getDeepObj(peserta, 'ptk.tgl_lahir') ? $getAge($getDeepObj(peserta, 'ptk.tgl_lahir')) : '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" lg="4">
                    <div class="caption grey--text text-lighten-1">
                      Status
                    </div>
                    <div class="body-2 mb-0">
                      {{ ajuan.ptk_id === peserta.ptk_id ? 'Kepala Sekolah' : 'Guru' }}
                    </div>
                    <template v-if="ajuan.ptk_id !== peserta.ptk_id">
                      <div class="caption grey--text text-lighten-1">
                        Mapel Diampu
                      </div>
                      <div class="body-2 mb-0">
                        {{ peserta.mapel_ajar }}
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        <div class="px-0 body-2" style="height: 24px">
          Pilih guru yang sesuai
        </div>
        <v-autocomplete
          v-model="form"
          :items="kandidats"
          placeholder="Silakan ketik untuk mencari nama guru"
          clearable
          hide-no-data
          single-line
          item-text="nama"
          item-value="ptk_id"
          dense
          outlined
        >
          <template v-slot:selection="data">
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.nama }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.ptk_id }}
              </v-list-item-subtitle>
              <div class="d-flex flex-wrap">
                <span class="mr-2" style="font-size: 12px">
                  <template v-if="data.item.is_peserta_pkp">
                    <v-icon color="success" x-small>mdi-check-circle</v-icon>
                    Peserta Diklat PKP: <span class="green--text">Ya</span>
                  </template>
                  <template v-else>
                    <v-icon color="error" x-small>mdi-close-circle</v-icon>
                    Peserta Diklat PKP: <span class="error--text">Tidak</span>
                  </template>
                </span>
              </div>
            </v-list-item-content>
          </template>
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.nama }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.ptk_id }}
              </v-list-item-subtitle>
              <div class="d-flex flex-wrap">
                <span class="mr-2" style="font-size: 12px">
                  <template v-if="data.item.is_peserta_pkp">
                    <v-icon color="success" x-small>mdi-check-circle</v-icon>
                    Peserta Diklat PKP: <span class="green--text">Ya</span>
                  </template>
                  <template v-else>
                    <v-icon color="error" x-small>mdi-close-circle</v-icon>
                    Peserta Diklat PKP: <span class="error--text">Tidak</span>
                  </template>
                </span>
              </div>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    ajuan: {
      type: Object,
      default: () => {},
    },
    kandidats: {
      type: Array,
      default: () => [],
    },
    pesertas: {
      type: Array,
      default: () => [],
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: [],
    };
  },
  methods: {
    reset(values = []) {
      this.$set(this, 'form', values[0]);
    },

    getValue() {
      return [{ ptk_id: this.form }];
    },
  },
};
</script>

<style scoped>
>>> .v-list-item__content {
  flex: auto !important;
}

.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
